import { render, staticRenderFns } from "./PerformanceCommonDialog.vue?vue&type=template&id=068d209e&"
import script from "./PerformanceCommonDialog.vue?vue&type=script&lang=js&"
export * from "./PerformanceCommonDialog.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceCommonDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports